commusoftCommon.filter('limitHtml', ["$filter", function ($filter) {
    return function(text, limit) {
        var changedString = String(text).replace(/<[^>]+>/gm, '');
        var length = changedString.length;

        return changedString.length > limit ? changedString.substr(0, limit - 1) + ' ...' : changedString;
    };
}]);